/* eslint-disable camelcase */

const LOAN_MULTIPLE = 4.5

type MortgageObj = {
  annualIncome: number
  otherIncome: number
  additionalAnnualIncome: number
  additionalOtherIncome: number
  deposit: number
}

type LoanDetails = {
  estPropertyBudget: number
  borrowing: number
  loanToValue: string
  deposit: number
}

export const mortgageCalculation = ({
  annualIncome,
  otherIncome,
  deposit,
}: MortgageObj): LoanDetails => {
  const totalIncome = annualIncome + otherIncome
  let estPropertyBudget = totalIncome * LOAN_MULTIPLE + deposit
  let borrowing = estPropertyBudget - deposit

  const depositPercentCalc = (deposit / estPropertyBudget) * 100

  if (depositPercentCalc <= 5) {
    estPropertyBudget = (deposit / 5) * 100
    borrowing = estPropertyBudget - deposit
  }
  const loanToValue = formatAsPercent(borrowing, estPropertyBudget, true)

  return {
    estPropertyBudget,
    deposit,
    borrowing,
    loanToValue,
  }
}

function formatAsPercent(borrowing: number, estPropertyBudget: number, isDisplay: boolean) {
  const amount = isDisplay ? 0 : 2
  return new Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: amount,
    maximumFractionDigits: amount,
  }).format(borrowing / estPropertyBudget)
}
